import type { Palette, PaletteColor } from "@mui/material";

export const isPaletteColor = (pc: unknown, pcKey: keyof PaletteColor): pc is PaletteColor => {
  return (pc as PaletteColor)[pcKey] !== undefined && typeof (pc as PaletteColor)[pcKey] === "string";
};

export const getColor = (
  palette: Palette,
  color: string | undefined,
  pcKey: keyof PaletteColor,
  defaultColor?: string
): string | undefined => {
  let backgroundColor = defaultColor;

  if (color) {
    const paletteColor = palette[color] as unknown;

    if (isPaletteColor(paletteColor, pcKey)) {
      backgroundColor = paletteColor[pcKey];
    }
  }

  return backgroundColor;
};
